module.exports = __webpack_public_path__ + "fonts/Inter-500-cyrillic-ext29.251d36f.woff2";